import { Luscinia, luscinia } from "./luscinia";

// Create interactive validation/alert box as child of given element
luscinia.createInteractiveValidator = function (element, validationError) {
    var html = "<div class='alert interactive-alert alert-" + validationError.Style + "'><span>" + validationError.Message + "</span>";
    for (var i = 0; i < validationError.Inputs.length; ++i) {
        switch (validationError.Inputs[i].InputType) {
            case 1:
                html += "<div class='form-group col-xs-2 pull-right'><input type='text' value='" + validationError.Inputs[i].Value + "' placeholder='" + validationError.Inputs[i].Caption + "' onchange='luscinia.interactiveValidatorResponse(this, \"" + validationError.PropertyName + "\", \"" + validationError.Inputs[i].Reference + "\", this.value)' class='form-control input-sm has-" + validationError.Inputs[i].Style + " ' /></div>";
                break;
            default:
                html += "<a href='javascript:void(0)' onclick='luscinia.interactiveValidatorResponse(this, \"" + validationError.PropertyName + "\", \"" + validationError.Inputs[i].Reference + "\", \"" + validationError.Inputs[i].Value + "\")' class='pull-right btn btn-xs btn-" + validationError.Inputs[i].Style + " '>" + validationError.Inputs[i].Caption + "</a>";
        }
    }
    html += "</div>";
    $(element).append(html);
};

// Post back interactive validator response
luscinia.interactiveValidatorResponse = function (element, columnName, reference, value) {
    var frm = $("#editModal" + luscinia.getModalLayerCount() + "Form");

    // Get form data
    var formData = new FormData((frm[0] as HTMLFormElement));

    $.ajax({
        type: "post",
        url: frm.data(luscinia.data.modulePath) + "/interactivevalidatorresponse/" + columnName + "/" + reference + "/" + value,
        cache: false,
        contentType: false,
        processData: false,
        data: formData,
        success: function (data) {
            $(element).parent().fadeOut(500);
        }
    });
};

class ValidationError {
    ///Actually contains Array<InteractiveValidatorInput>
    inputs: Array<any>;
    message: string;
    propertyName: string;
}

luscinia.refreshValidation = function (errorMessage, frm: JQuery<HTMLFormElement>, frmSelector: string) {
    // Get error
    var errors = errorMessage;
    var modalerror = $(frmSelector + "-luscinia-modal-message");
    var modalerrorText = modalerror.find(frmSelector + "-luscinia-modal-message-text");

    // Initialise error indicators
    modalerror.css("height", "auto").css("opacity", 1);
    frm.find(".has-error").removeClass("has-error");
    frm.find(".help-block").text("");
    modalerror.hide();
    modalerrorText.text("");
    var showTabInput;
    if (Array.isArray(errors)) {
        for (let i = 0; i < errors.length; ++i) {
            let error: ValidationError = errors[i];
            if (error.propertyName !== "") {
                var inputElement = frm.find("[id='" + frmSelector.replace("#", "") + "-luscinia-forminput-" + (error.propertyName || "").toLowerCase() + "']");
                if (inputElement.length === 0) {
                    inputElement = frm.find("[id^='" + frmSelector.replace("#", "") + "-luscinia-forminput-" + (error.propertyName || "").toLowerCase() + "']");
                }
                if (inputElement.length === 0 && error.propertyName.toLowerCase().includes("fileid")) {
                    inputElement = frm.find("#FileUpload" + frmSelector.replace("#", "") + "-luscinia-forminput-" + (error.propertyName || "").toLowerCase());
                }
                if (i === 0) {
                    showTabInput = inputElement;
                }
                inputElement.closest(".property-container").addClass("has-error");
                var helpBlocks;
                helpBlocks = inputElement.parent().find(".help-block");
                if (helpBlocks.length === 0) {
                    helpBlocks = inputElement.parent().parent().find(".help-block");
                }

                if (error.inputs.length > 0) {
                    luscinia.createInteractiveValidator(helpBlocks[0], error);
                } else {
                    helpBlocks.each(function (e) {
                        if ($(this).text() === "") {
                            $(this).html(error.message);
                        } else {
                            $(this).html($(this).text() + "</br>" + error.message);
                        }
                    });
                }
            }
        }
        if (errors.length > 0) {
            let inputElementToFocus: JQuery<HTMLElement> = null;
            for (let error of errors) {
                let element = frm.find("[id^='" + frmSelector.replace("#","") + "-luscinia-forminput-" + (error.propertyName || "").toLowerCase() + "']");
                if (element.length === 0 && error.propertyName.toLowerCase().includes("fileid")) {
                    element = frm.find("#FileUpload" + frmSelector.replace("#", "") + "-luscinia-forminput-" + (error.propertyName || "").toLowerCase());
                }
                if (element.length > 0) {
                    if (element.is(":hidden")) {
                        element = element.parent();
                    }
                    if (inputElementToFocus === null || element.offset().top < inputElementToFocus.offset().top) {
                        inputElementToFocus = element;
                    }
                }
            }
            if (inputElementToFocus !== null) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: inputElementToFocus.offset().top - 20
                }, 1000);
                inputElementToFocus.focus();
            }
        }
    }
    else {
        if (typeof errors === "string") {
            if (errors.includes("<!DOCTYPE html>")) {
                var errorEnd = errors.indexOf("<!DOCTYPE html>");
                errors = errors.substring(0, errorEnd);
            }
        }
        if (typeof errors === "object") {
            modalerror.html(errors.Exception + "</br>" + errors.ExceptionDetails);
        }
        else if (modalerrorText.text() === "") {
            modalerrorText.html(errors);
        } else {
            modalerrorText.html($(this).text() + "</br>" + errors);
        }
        modalerror.find("i").removeClass().addClass("fa fa-times-circle sign");
        modalerror.removeClass().addClass("alert alert-danger");
        modalerror.show();
    }
    return showTabInput;
};

luscinia.maxFileSize = function (fileInput: HTMLInputElement, maxByteSize: number, errorMessage: string) {
    if (fileInput.value) {
        if (fileInput.files[0].size > maxByteSize * 1024) {
            alert(errorMessage);
            $(fileInput).val("");
            return false;
        }
    }
};

luscinia.validateFileFormat = function (fileInput: HTMLInputElement, errorMessage: string) {
    let valid = false;
    if (!fileInput.accept) {
        valid = true;
    }
    valid = fileInput.accept.replace(/\s/g, '').split(',').filter(function(accept) {
        return new RegExp(accept.replace('*', '.*')).test(fileInput.files[0].type);
    }).length > 0;
    if (!valid) {
        alert(errorMessage);
        $(fileInput).val("");
    }
};

luscinia.removeErrors = function (input: HTMLInputElement) {
    const propertyContainer = input.closest('.property-container');
    propertyContainer.classList.remove('has-error');
    const helpBlock = propertyContainer.querySelector('.help-block');
    if (helpBlock) {
        helpBlock.textContent = '';
    }
}
